<template>
  <el-container>
    <el-header height="80px">
      <div class="header-cont">
        <div style="width:50%;padding-top: 8px;padding-left: 30px;">
          <img src="../../assets/images/logo1-default.png" alt="汉森办公">
        </div>
        <div style="width:50%;">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <!--<el-dropdown-item command="a">{{ $t('userDropdownMenu.basicInfor') }}</el-dropdown-item>-->
              <el-dropdown-item command="changePassword">{{ $t('userDropdownMenu.changePassword') }}</el-dropdown-item>
              <el-dropdown-item command="logout" divided>{{ $t('userDropdownMenu.logout') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </el-header>
    <el-main class="table-main" id="main">
      <el-form :model="form">
        <el-row type="flex" justify="space-between">
          <el-col :span="13">
            <div class="grid-content">
              <span class="moreSys" v-if="systemsAllList.length>6" @click="viewAllSys">更多>></span>
              <ul class="systems">
                <li v-for="(item,index) in systemsList" :key="item.name+index">
                  <div class="icon-ground cursor" @click="goSystem(item)">
                    <!-- <a :href="item.href" target="_black" style="display: inline-block;height: 100%;"> -->
                      <div class="icon-cycle">
                        <i></i>
                        <span>{{item.name}}</span>
                      </div>
                    <!-- </a> -->
                  </div>
                </li>
              </ul>
            </div>
          </el-col>
          <el-col :span="13">
            <div class="grid-content padding-none">
              <el-carousel trigger="click" height="160px" width="100%">
                <el-carousel-item v-for="item in picList" :key="item.src">
                  <img :src="item.src" alt="">
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="13">
            <div class="grid-content padding-none height-290" style="position: relative;">
              <span class="moreSys" @click="leftMore">更多>></span>
              <el-tabs type="border-card" class="news" v-model="leftActiveName">
                <el-tab-pane label="待办" name="first">
                  <el-table :data="form.upcoming" style="width: 100%" height="300">
                    <el-table-column
                      prop="flowName"
                      label="流程标题"
                      :show-overflow-tooltip="true"
                      width="300">
                      <template slot-scope="scope">
                        <el-button type="text" @click="goDetail('MyApprovalPend', scope.row)">{{ scope.row.applyDeptName + scope.row.applyUserName + '提交的' + scope.row.flowName }}</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="right"
                      prop="createTime"
                      :formatter="changeTime"
                      label="申请时间">
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane label="我的消息"  name="second">
                  <el-table :data="form.myInfo" class="news" style="width: 100%" height="300">
                    <el-table-column
                      prop="msgBody"
                      label="消息标题"
                      :show-overflow-tooltip="true"
                      width="300">
                      <template slot-scope="scope">
                        <el-button type="text" @click="goDetail('MyMessage', scope.row)">{{ scope.row.msgBody }}</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="right"
                      prop="beginDay"
                      :formatter="changeTime"
                      label="推送时间">
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>
          <el-col :span="13">
            <div class="grid-content padding-none height-290" style="position: relative;">
              <span class="moreSys" @click="rightMore">更多>></span>
              <el-tabs type="border-card" v-model="rightActiveName">
                <el-tab-pane label="通知公告" name="first">
                  <el-table :data="form.noticesList" class="news" style="width: 100%" height="300">
                    <el-table-column
                      prop="title"
                      :show-overflow-tooltip="true"
                      width="400"
                      label="标题"
                    >
                      <template slot-scope="scope">
                        <el-button type="text" @click="goDetail('MyNoticeView', scope.row)">{{ scope.row.title }}</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="right"
                      prop="createTime"
                      label="申请时间"
                      :formatter="changeTime"
                    >
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane label="公司新闻" name="second">
                  <el-table :data="form.newsList" class="news" style="width: 100%" height="300">
                    <el-table-column
                      prop="title"
                      :show-overflow-tooltip="true"
                      label="标题"
                    >
                      <template slot-scope="scope">
                        <el-button type="text" @click="goDetail('MyNewsView', scope.row)">{{ scope.row.title }}</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="right"
                      prop="publishTime"
                      label="申请时间"
                      width="150"
                      :formatter="changeTime"
                    >
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>
        </el-row>
        <!-- <el-row type="flex" justify="center">
          <el-col :span="24">
            <div class="favorites">
              <div class="favorites-title">
                <span>收藏夹</span>
              </div>
              <div>
                <el-button type="params" size="small">数据字典</el-button>
              </div>
            </div>
          </el-col>
        </el-row> -->
      </el-form>
    </el-main>
    <el-footer class="table-footer">
    </el-footer>
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" id="dialog">
      <el-form :model="dialogForm" label-width="80px">
        <el-form-item label="原密码 " prop="oldPassword">
          <el-input v-model="dialogForm.oldPassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="dialogForm.newPassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码 " prop="reNewPassword">
          <el-input v-model="dialogForm.reNewPassword" show-password></el-input>
        </el-form-item>
        <el-footer class="table-footer" align="right">
          <el-button type="primary" @click="updateUser(dialogForm)">确 定</el-button>
          <el-button @click="dialogFormVisible = false">取 消</el-button>
        </el-footer>
      </el-form>
    </el-dialog>
    <el-dialog title="我的系统" :visible.sync="dialogVisible" id="dialog">
      <div>
        <ul class="systemsAll">
          <li v-for="(item,index) in systemsAllList" :key="item.name+index">
            <div class="icon-ground cursor" @click="goSystem(item)">
              <!-- <a :href="item.href" target="_black" style="display: inline-block;height: 100%;"> -->
                <div class="icon-cycle">
                  <i></i>
                  <span>{{item.name}}</span>
                </div>
              <!-- </a> -->
            </div>
          </li>
          <li class="hotLis"></li>
          <li class="hotLis"></li>
          <li class="hotLis"></li>
          <li class="hotLis"></li>
          <li class="hotLis"></li>
        </ul>
      </div>
    </el-dialog>
    <el-dialog
      title="通知公告"
      :visible.sync="noticeDialogVisible"
      fullscreen
      >
        <notice-list></notice-list>
    </el-dialog>
    <el-dialog
      title="待办"
      :visible.sync="upcomeDialogVisible"
      width="60%"
      >
        <upcome-list></upcome-list>
    </el-dialog>
    <el-dialog
      title="我的消息"
      :visible.sync="msgDialogVisible"
      fullscreen
      >
        <msg-list></msg-list>
    </el-dialog>
    <el-dialog
      title="公司新闻"
      :visible.sync="newsDialogVisible"
      fullscreen
      >
        <news-list></news-list>
    </el-dialog>
  </el-container>
</template>

<script>
import moment from "moment"
import Cookies from 'js-cookie'
import noticeList from './components/noticeList'
import upcomeList from './components/upcomeList'
import newsList from './components/newsList'
import msgList from './components/msgList'

export default {
  data() {
    return {
      dialogFormVisible: false,
      dialogVisible: false,
      form: {
        upcoming: [
        ],
        newsList: [
        ],
        noticesList: [
        ],
        myInfo: []
      },
      picList: [
        {
          src: require('../../assets/images/main-banner1.jpg')
        },{
          src: require('../../assets/images/main-banner2.jpg')
        }
      ],
      userName: '',
      dialogForm: {},
      systemsList:[
      ],
      leftActiveName: 'first',
      rightActiveName: 'first',
      systemsAllList: [],
      noticeDialogVisible: false,
      upcomeDialogVisible: false,
      newsDialogVisible: false,
      msgDialogVisible: false
    };
  },
  components: {
    noticeList,
    upcomeList,
    newsList,
    msgList
  },
  created(){
    this.loadSystem()
    this.loadNews()
    this.loadNotice()
    this.loadMyInfo()
    this.loadUpcome()
    let userName = JSON.parse(localStorage.getItem('user')).userName
    if (userName) {
      this.userName = userName
    }
  },
  methods: {
    goDetail(pageName, pageData){
      let user = JSON.parse(localStorage.getItem('user'))
      user.systemId = 1
      // user.roleId = -20
      localStorage.setItem("user",JSON.stringify(user));
      localStorage.setItem('pageData', JSON.stringify(pageData))
      if(pageName === 'MyMessage'){
        localStorage.setItem('pageName', pageData.bizCode)
        if(pageData === 20){
          let formData = new FormData()
          formData.append('msgCode', pageData.msgCode)
          this.$axios.post(this.global.BASE_INFO+'/message/read',formData)
            .then(res=>{
              if(res.data.status === 'Y'){
                window.open(window.location.origin+'/mgr/#/index')
              }
            })
        }
        window.open(window.location.origin+'/mgr/#/index')
      } else {
        localStorage.setItem('pageName', pageName)
        window.open(window.location.origin+'/mgr/#/index')
      }
    },
    handleClose(){},
    //系统跳转
    goSystem(val){
      let user = JSON.parse(localStorage.getItem('user'))
      user.systemId = val.systemId
      user.roleId = val.roleId
      localStorage.setItem("user",JSON.stringify(user));
      localStorage.setItem("roleName",val.name);
      localStorage.setItem('isMenu', true)
      console.log(JSON.parse(localStorage.getItem('user')))
      window.open(window.location.origin+'/mgr/#/index')
    },
    //新闻
    loadNews(){
      this.$axios.post(this.global.BASE_INFO+'/article/findWebArticle',{
        data:{},
        pageIndex:0,
        pageSize:6
      }).then(res=>{
        if(res.data.status === 'Y'){
          let array=res.data.data;
          for (let index = 0; index < array.length; index++) {
            if(array[index].status=='50')
            this.form.newsList.push(array[index])
          }
        }
      })
    },
    //公告
    loadNotice(){
      this.$axios.post(this.global.BASE_INFO+'/notice/findNotice',{
        data:{},
        pageIndex:0,
        pageSize:6
      }).then(res=>{
        if(res.data.status === 'Y'){
          this.form.noticesList = res.data.data
        }
      })
    },
    // 我的消息
    loadMyInfo(){
      let userInfoId = JSON.parse(localStorage.getItem('user')).userInfoId
      this.$axios.post(this.global.BASE_INFO+'/message/find',{
        data:{
          type: 'All'
        },
        pageIndex:0,
        pageSize:6
      }).then(res=>{
        if(res.data.status === 'Y'){
          this.form.myInfo = res.data.data
        }
      })
    },
    // 待办
    loadUpcome(){
      let user = JSON.parse(localStorage.getItem('user'))
      this.$axios.post(this.global.BASE_URL+'/msi/cbc/biz/common/find',{
        data:{
          pageCode: "MyTask",
          pageLocation: "List",
          params: {
            approveFlag: "Y",
            taskOwer: user.loginName
          }
        },
        asp: user.asp,
        pageIndex:0,
        pageSize:6
      }).then(res=>{
        if(res.data.status === 'Y'){
          this.form.upcoming = res.data.data
        }
      })
    },
    viewAllSys(){
      this.dialogVisible = true
    },
    rightMore(){
      let user = JSON.parse(localStorage.getItem('user'))
      user.systemId = 1
      // user.roleId = -20
      localStorage.setItem("user",JSON.stringify(user));
      if(this.rightActiveName === 'first'){
        // this.noticeDialogVisible = true
        localStorage.setItem('pageName', 'MyNotice')
        window.open(window.location.origin+'/mgr/#/index')
      } else if(this.rightActiveName === 'second'){
        localStorage.setItem('pageName', 'MyNews')
        window.open(window.location.origin+'/mgr/#/index')
      }
    },
    leftMore(){
      let user = JSON.parse(localStorage.getItem('user'))
      user.systemId = 1
      // user.roleId = -20
      localStorage.setItem("user",JSON.stringify(user));
      localStorage.setItem('isMenu', true)
      if(this.leftActiveName === 'first'){
        
        localStorage.setItem('pageName', 'MyApproval')
        window.open(window.location.origin+'/mgr/#/index')
        // this.upcomeDialogVisible = true
      } else if(this.leftActiveName === 'second'){
        // this.msgDialogVisible = true
        localStorage.setItem('pageName', 'MyMessage')
        window.open(window.location.origin+'/mgr/#/index')
      }
    },
    //系统
    loadSystem(){
      let user = JSON.parse(localStorage.getItem('user'))
      this.$axios.post(this.global.BASE_INFO + "/role/findUserRole",{
        data: {
          userId: user.userInfoId
        },
        pageIndex: 0,
        pageSize: 99,
        asp: user.asp
      }).then(res=>{
        if(res.data.status === 'Y'){
          res.data.data.forEach((item, index)=>{
            if(index<6){
              this.systemsList.push({
                name: item.roleName,
                href: item.roleType=='90'?item.url : window.location.origin+'/mgr/#/index',
                systemId: item.systemId,
                roleId: item.roleId,
              })
            }
            this.systemsAllList.push({
              name: item.roleName,
              href: item.roleType=='90'?item.url : window.location.origin+'/mgr/#/index',
              systemId: item.systemId,
              roleId: item.roleId,
            })
          })
        }
      })
    },
    updateUser (form) {
      if(!this.dialogForm.newPassword){
        this.$message({
          showClose: true,
          message: '密码不能为空',
          type: 'error'
        })
        return false
      }
      if (this.dialogForm.newPassword != this.dialogForm.reNewPassword) {
        this.$message({
          showClose: true,
          message: '两次输入密码不一致',
          type: 'error'
        })
        return false
      }
      let userId = JSON.parse(localStorage.getItem('user')).userId
      let userType = JSON.parse(localStorage.getItem('user')).userType
      let param = {
        data: {
          userId: userId,
          type: userType,
          oldPassword: this.dialogForm.oldPassword,
          newPassword: this.dialogForm.newPassword
        }
      }
      this.$axios({
        method: 'post',
        url: this.global.BASE_ACL + '/user/updateUserPasswd',
        data: JSON.stringify(param),
        headers: {
          certificate: Cookies.get(`token_${window.location.port}`),
          'Content-Type': 'application/json'
        }
      }).then((response) => {
        if (response.data.status === 'Y') {
          this.$message({
            showClose: true,
            message: response.data.data,
            type: 'success'
          })
          Cookies.remove('token')
          location.reload()
        } else {
          this.$message({
            showClose: true,
            message: response.data.data,
            type: 'error'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    handleCommand (command) {
      if (command === 'logout') {
        // 退出方法
        this.$axios({
          method: 'post',
          url: this.global.BASE_DMZ + '/staff/logout',
          headers: {
            certificate: Cookies.get(`token_${window.location.port}`)
          },
          //   beforeSend: function(request) {
          // 	  debugger
          // 	 request.setRequestHeader("token", Cookies.get(`token_${window.location.port}`));
          // },
          data: this.qs.stringify({
            certificate: Cookies.get(`token_${window.location.port}`)
          })
        }).then((response) => {
          Cookies.remove('token')
          location.reload()
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      } else if (command === 'changePassword') {
        this.dialogFormVisible = true
      }
    },
    changeTime(row, column) {
      let date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
  }
};
</script>
<style scoped>
html,body{
  color: rgba(0, 0, 0, 0.65);
  background-color: #f6f6f6;
}
a{
  text-decoration: none;
}
#dialog >>> .el-dialog__title {
  font-size: 14px;
}
#dialog >>> .el-dialog__header {
  background: #fff;
}
.grid-content{
  height: 150px;
  margin: 10px;
  padding: 0 10px;
  background: #fff;
  position: relative;
  overflow: hidden;
}
.grid-content .moreSys {
  position: absolute;
  right: 15px;
  top: 10px;
  cursor: pointer;
  z-index: 100;
}
.el-header{
  padding:0
}
.el-main {
  padding: 0 10px;
}
.header-cont{
  background:#fff;
  height:80px;
  display: flex;
}
/* 登录信息 */
.el-dropdown{
  float: right;
  margin-right: 30px;
  line-height: 80px;
}
/* 系统展示 */
.systems,.systemsAll{
  height: 100%;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
  align-items: center;
}
.systemsAll::after {
  content: '';
  width: 16%;
}
.hotLis {
  width: 16%;
  content: '';
}
.systems li{
  height: 85px;
  /* padding-top: 25px; */
  width: 16%;
  /* overflow: hidden; */
  list-style-type: none;
}
.icon-ground{
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-align: center;
  align-items: center;
}
.icon-ground a:hover .icon-cycle i{
  top: -10px;
}
.icon-cycle{
  display: flex;
  align-items: baseline;
  height: 100%;
  flex-direction: column;
  align-items: center;
}
.icon-cycle i{
  position: relative;
  top: 0;
  transition: all .5s;
  height: 50px;
  width: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 50%;
  overflow: hidden;
  color: #fff;
  display: block;
  background: green;
  margin-bottom: 15px;
}
.systemsAll .icon-cycle span {
  font-size: 12px;
}
/* 查询所有系统 */
.systemsAll li{
  list-style-type: none;
  width: 16%;
  padding-top: 10px;
}
.systemsAll li:nth-child(n+7) {
  padding-top: 25px;
}
/* 轮播 */
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 160px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
/* 消息 */
#main>>>.el-tabs--border-card>.el-tabs__header{
  background:#fff
}
#main>>>.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active,
#main>>>.el-tabs--border-card>.el-tabs__header .el-tabs__item:hover{
  border-bottom: 1px solid #106ecc !important;
 color: #c7180c;
  font-weight: 600;
}
#main>>>.el-tabs--border-card>.el-tabs__header .el-tabs__item {
  border: none;
}
.el-button--text {
 color: #c7180c;
}
.el-button--text:hover{
  color:#1d86f0;
}
.el-table {
 color: #c7180c;
}
/* 收藏 */
.favorites{
  min-height: 90px;
  margin: 20px;
  background: #fff;
  padding: 0 30px;
}
.favorites-title{
  height: 36px;
  line-height: 36px;
}

.padding-none{
  padding: 0
}
.height-290{
  height: 290px;
}
.cursor{
  cursor: pointer;
}
/* 表格 */
#main>>>.el-tabs--border-card>.el-tabs__content {
  padding: 5px 20px;
  height: 254px;
}
#main>>>.table-main .el-table td{
  font-size: 12px;
  padding: 5px 0;
}
#main>>>.el-table .cell{
  line-height: 29px;
  overflow: hidden;
  color:rgba(0, 0, 0, 0.65);
}
#main >>>.el-table th{
  background: #fff;
  font-weight: bolder;
  font-size: 14px;
  color: #000;
}
#main>>>.el-table tr:not(:last-child) td{
  border-bottom: 1px solid #EBEEF5;
}
#main>>>.el-table::before{
  height: 0
}
#main>>>.el-table tr:last-child td{
  border-bottom: none;
}
#main>>>.el-table__row:hover > td {
  background-color: #ffffff !important;
}
#main>>>.el-tabs--border-card,#main>>>.el-tabs--border-card>.el-tabs__header,#main>>>.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
  border: none;
}
.news>>>.el-table__header-wrapper{
  display: none;
}



#main>>>.el-tabs--border-card>.el-tabs__header .el-tabs__item {
  color: #33383d;
}
</style>


// WEBPACK FOOTER //
// src/views/main/index-old.vue